<div (click)="callParentMethod()" [ngStyle]="{ height: is_full_size_icon ? '100%' : '' }">
  @switch (IconName) { @case ('jpg') {
  <img
    [ngStyle]="{ opacity: isActive ? '1' : '.7' }"
    [ngClass]="{
      'extra-large-icon': is_full_size_icon,
      'scaled-down-loading-icon': is_large_icon && !filsrData && !is_full_size_icon,
      'large-icon': is_large_icon && filsrData && !is_full_size_icon,
      'icon-mdeium': !is_full_size_icon && !is_large_icon,
      'set-padding-loading': !filsrData
    }"
    style="border-radius: 8px 8px 0px 0px"
    [style.width.%]="filsrData ? '100' : ''"
    [src]="filsrData ? filsrData : loadingUrl"
  />
  } @case ('png') {
  <img
    [ngStyle]="{ opacity: isActive ? '1' : '.7' }"
    [ngClass]="{
      'extra-large-icon': is_full_size_icon,
      'scaled-down-loading-icon': is_large_icon && !filsrData && !is_full_size_icon,
      'large-icon': is_large_icon && filsrData && !is_full_size_icon,
      'icon-mdeium': !is_full_size_icon && !is_large_icon,
      'set-padding-loading': !filsrData
    }"
    style="border-radius: 8px 8px 0px 0px"
    [style.width.%]="filsrData ? '100' : ''"
    [src]="filsrData ? filsrData : loadingUrl"
  />
  } @case ('heic') {
  <img
    [ngStyle]="{ opacity: isActive ? '1' : '.7' }"
    [ngClass]="{
      'extra-large-icon': is_full_size_icon,
      'scaled-down-loading-icon': is_large_icon && !is_full_size_icon && !filsrData && heicfileconverted,
      'large-icon': is_large_icon && !is_full_size_icon && (filsrData || !heicfileconverted),
      'icon-mdeium': !is_full_size_icon && !is_large_icon,
      'set-padding-loading': !filsrData
    }"
    style="border-radius: 8px 8px 0px 0px"
    [style.width.%]="filsrData ? '100' : ''"
    [src]="heicfileconverted ? (filsrData ? filsrData : loadingUrl) : 'assets/images/file-extensions/HEIC.svg'"
  />
  } @case ('jpeg') {
  <img
    [ngStyle]="{ opacity: isActive ? '1' : '.7' }"
    [ngClass]="{
      'extra-large-icon': is_full_size_icon,
      'scaled-down-loading-icon': is_large_icon && !filsrData && !is_full_size_icon,
      'large-icon': is_large_icon && filsrData && !is_full_size_icon,
      'icon-mdeium': !is_full_size_icon && !is_large_icon,
      'set-padding-loading': !filsrData
    }"
    style="border-radius: 8px 8px 0px 0px"
    [style.width.%]="filsrData ? '100' : ''"
    [src]="filsrData ? filsrData : loadingUrl"
  />
  } @case ('pdf' ) {
  <div style="display: flex">
    <pdf-viewer
      [src]="filsrData"
      [rotation]="0"
      [original-size]="false"
      [fit-to-page]="false"
      [stick-to-page]="true"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      [stick-to-page]="false"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"
      style="width: 100%"
      [ngStyle]="{
        height: is_full_size_icon ? '602px' : is_large_icon ? '248px' : '120px'
      }"
    ></pdf-viewer>
  </div>
  } @default { @if(is_small_preview){
  <div class="m-auto" style="border-radius: 8px 8px 0px 0px; padding-top: 25% !important; width: 100%; background: #e3e3e3; height: 260px">
    <img
      [ngStyle]="{ opacity: isActive ? '1' : '.7' }"
      [ngClass]="is_full_size_icon ? 'extra-large-icon' : is_large_icon ? 'large-icon' : 'icon-mdeium'"
      class="static-icon-mode"
      style="height: 96px !important"
      src="assets/images/file-preview-not-avaialbel.svg"
    />
    <p class="text-sm font-bold text-[#18191c] text-center">Preview not Available</p>
  </div>
  }@else if(is_medium_preview){
  <div class="m-auto" style="padding-top: 52% !important; width: 100%; background: #e3e3e3; height: 100%; padding-bottom: 15%">
    <img
      [ngStyle]="{ opacity: isActive ? '1' : '.7' }"
      [ngClass]="is_full_size_icon ? 'extra-large-icon' : is_large_icon ? 'large-icon' : 'icon-mdeium'"
      class="static-icon-mode"
      style="height: 80px !important"
      src="assets/images/file-preview-not-avaialbel.svg"
    />
    <p class="font-semibold text-sm m-0 text-[#18191c] text-center">Preview not Available</p>
  </div>
  }@else{
  <div class="m-auto" style="padding: 31% 0!important; width: 100%; background: #e3e3e3; height: 100%">
    <img
      [ngStyle]="{ opacity: isActive ? '1' : '.7' }"
      [ngClass]="is_full_size_icon ? 'extra-large-icon' : is_large_icon ? 'large-icon' : 'icon-mdeium'"
      class="static-icon-mode"
      style="height: 80px !important"
      src="assets/images/file-preview-not-avaialbel.svg"
    />
    <p class="font-semibold text-sm m-0 text-[#18191c] text-center">Preview not Available</p>
  </div>
  } } }
</div>
